import { API, Auth } from 'aws-amplify';
// import awsconfigDEV from './../awsconfiguration-dev.json';
// import awsconfigPRO from './../awsconfiguration-pro.json';
// import { errorHandle } from './../errorHandle';
// const tk = require('timekeeper');
// const getVideo = async (newUrl) => {
//   const cred = await Auth.currentCredentials();
//   const AWS = require('aws-sdk');

//   const getTruncatedTime = () => {
//     const currentTime = new Date();
//     const d = new Date(currentTime);

//     d.setMinutes(Math.floor(d.getMinutes() / 10) * 10);
//     d.setSeconds(0);
//     d.setMilliseconds(0);

//     return d;
//   };

//   const SESConfig = {
//     credentials: cred,
//     region: 'us-east-1',
//   };
//   AWS.config.apiVersions = {
//     s3: '2006-03-01',
//     // other service API versions
//   };
//   AWS.config.update(SESConfig);
//   const s3 = new AWS.S3();
//   let myBucket = awsconfigPRO.S3.bucket;
//   if (!window.location.href.includes('wearefriends.cool')){
//     myBucket = awsconfigDEV.S3.bucket;
//   }
//   const myKey = newUrl;
//   const signedUrlExpireSeconds = 60 * 50; // your expiry time in seconds.
//   const urlFound =  tk.withFreeze(getTruncatedTime(), () => {
//     return s3.getSignedUrl('getObject', {
//       Bucket: myBucket,
//       Key: myKey,
//       Expires: signedUrlExpireSeconds,
//     });
//   });
//   // await fetch(urlFound).then(response => {
//   //     if(response.status === 200){
//   //     }
//   //     else{
//   //       response.text().then(text => {
//   //         errorHandle(newUrl.split("/")[1], text)
//   //       })      
//   //     }
//   // })
//   return urlFound;
// };

const getVideo = (baseUrl, login) => login.cloudFront + baseUrl + login.cookie;

const GetUserVideo = async (newUrl, login=null) => {
  if (newUrl.includes('appfiles') && login) {
    return getVideo(newUrl, login);
  } else {
    const myInit = {
      body: { key: newUrl },
    };
    const urlFound = await API.post('TIR', '/v3/student/url/download', myInit);
    // await fetch(urlFound.presigned_url).then(response => {
    //   if(response.status === 200){
    //   }
    //   else{
    //     response.text().then(text => {
    //       errorHandle(newUrl.split("/")[1], text)

    //     })
    //   }
    // })
    return urlFound.presigned_url;
  }
};

export { getVideo, GetUserVideo };
